export const cartDot = state => state.cartDot
export const cartNum = state => state.cartNum
export const cart = state => state.cart
export const msgNum = state => state.msgNum



// WEBPACK FOOTER //
// ./src/store/getters.js